module.exports = __webpack_public_path__ + "static/media/rugrats-player-login-dino.83d349b0.png";